'use client'

import { Link } from '@/i18n/routing'
import { usePathname } from 'next/navigation'

import classNames from 'classnames'
import type { ComponentProps } from 'react'

import { useBreadcrumbsStore } from '@/modules/breadcrumbs/hooks/use-breadcrumbs'
import Card from './Card'

import { IconPlus } from '@tabler/icons-react'
const CUSTOM_ROUTES = ['leistungen', 'projekte', 'news', 'agentur', 'lp']
const LOCALES = ['de', 'en']
// Segmente, deren Beschriftung capitalize falsch schreiben wuerde ("Wo Wir Helfen")
const SEGMENT_LABELS: Record<string, string> = { 'wo-wir-helfen': 'Wo wir helfen', 'how-we-help': 'How we help' }
export const Breadcrumbs = () => {
  const { currentRouteName } = useBreadcrumbsStore()
  const pathname = usePathname()
  const allSegments = pathname.split('/').filter(Boolean)
  const segments = allSegments.filter((segment) => segment !== 'lp' && !LOCALES.includes(segment))
  return (
    <Card className="hidden lg:flex flex-row! items-center p-8 gap-x-6 border border-accent rounded-3xl w-max">
      <IconPlus size={20} className="text-accent" />
      <ul className="flex flex-row items-center">
        {segments.map((segment, index) => {
          // href als DE-Pfad-Key ohne Locale-Präfix bauen: der i18n-Link mappt ihn dann
          // automatisch auf die lokalisierte URL (z.B. /leistungen -> /en/services), statt
          // wie vorher /en/leistungen zu rendern, was nur per Redirect auf /en/services zeigte.
          const segmentIndex = allSegments.indexOf(segment)
          const href = '/' + allSegments.slice(0, segmentIndex + 1).filter((s) => !LOCALES.includes(s)).join('/')
          const isLast = index === segments.length - 1

          const label = SEGMENT_LABELS[segment]
          let formatted = label ?? decodeURIComponent(segment.replace(/-/g, ' '))
          if (index === segments.length - 1 && currentRouteName) {
            if (segments.some((r) => CUSTOM_ROUTES.includes(r)) && !CUSTOM_ROUTES.includes(segments[segments.length - 1])) {
              formatted = currentRouteName
            }
          }
          return isLast ? (
            <li key={index} className={classNames('flex flex-row items-center text-white text-lg leading-none', { ['capitalize']: formatted !== currentRouteName && !label })}>
              {formatted}
            </li>
          ) : (
            <li key={index} className="flex flex-row items-center">
              <Link href={href as ComponentProps<typeof Link>['href']} className={classNames('font-medium text-white text-lg leading-none capitalize')}>
                {formatted}
              </Link>
              <span className="mx-1">-</span>
            </li>
          )
        })}
      </ul>
    </Card>
  )
}
